import { create } from "zustand";
import { AGENT_LIST } from "../Utils/constant";
import { find, getAgentByProfile, getAll } from "../services/service";
export const useStoreAgent = create((set) => ({
  loading: false,
  data: [],
  dispoAgents: [],
  technicien: [],
  technicienSans: [],
  agent: async (param, otherParam) => {
    set({
      loading: true,
      data: [],
    });

    try {
      const agents = await getAll(AGENT_LIST, param, otherParam);
      set({
        loading: false,
        data: agents.data,
      });
    } catch (error) {
      set({
        loading: true,
        data: [],
      });
    }
  },
  getData: async (profil) => {
    set({
      loading: true,
      data: [],
    });
    try {
      const agents = await getAgentByProfile(profil);
      set({
        loading: false,
        data: agents.data,
      });
    } catch (error) {
      set({
        loading: true,
        data: [],
      });
    }
  },
  agentDispo: async (url) => {
    set({
      loading: true,
      dispoAgents: [],
    });
    try {
      const agents = await find(url);
      set({
        loading: false,
        dispoAgents: agents.data,
      });
    } catch (error) {
      set({
        loading: true,
        dispoAgents: [],
      });
    }
  },
  technicienParEquipe: async (url) => {
    set({
      loading: false,
      technicien: [],
    });
    try {
      const agents = await find(url);
      set({
        loading: true,
        technicien: agents.data,
      });
    } catch (error) {
      set({
        loading: false,
        technicien: [],
      });
    }
  },
  technicienSansEquipe: async (url) => {
    set({
      technicienSans: [],
    });
    try {
      const agents = await find(url);
      set({
        technicienSans: agents.data,
      });
    } catch (error) {
      set({
        technicienSans: [],
      });
    }
  },
}));
